import Accordion from '@ui/accordion/Accordion';
import AccordionItem from '@ui/accordion/AccordionItem';
import analytics from '@utils/analytics';
import api from '@utils/api';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import customEventBus from '@common/scripts/libs/eventBus';
import GiftcardBalanceFAQ from './GiftcardBalanceFAQ';
//.hero-search class is for new faq search in CS Landing, .client-service-search class is for the old CS Landing search
const searchSelector = '.hero-search, .client-service-search';
const FaqResults = (props) => {
    const { t } = useTranslation();
    const [results, setResults] = useState([]);
    const [emptyPrevious, setEmptyPrevious] = useState(false);
    const emptyQuery = useRef(true);
    const [query, setQuery] = useState('');
    // inizializzo i ref per gli elementi del dom fuori react
    const searchBlock = useRef(document.querySelector(searchSelector));
    // add listener from outside via CustomEventBus
    useEffect(() => {
        customEventBus.on('faqSearch:update', (data) => {
            setResults(data.results);
        });
        customEventBus.on('query:update', (data) => {
            setQuery(data.query);
        });
    }, []);
    useEffect(() => {
        var _a;
        emptyQuery.current = query.length === 0;
        if (query.length >= 1) {
            api.searchFaqs(query).then((data) => {
                if (emptyQuery.current) {
                    return false;
                }
                else if (data.results.length > 0) {
                    searchBlock.current.dataset.searchActive = 'res';
                }
                else {
                    searchBlock.current.dataset.searchActive = 'sugg';
                }
                setResults(data.results || []);
                setEmptyPrevious(false);
            });
        }
        else {
            setEmptyPrevious(true);
            (_a = searchBlock.current) === null || _a === void 0 ? void 0 : _a.removeAttribute('data-search-active');
            setResults([]);
        }
    }, [query]);
    const getHtmlContent = (str) => {
        return React.createElement("div", { dangerouslySetInnerHTML: { __html: str } });
    };
    const thirdLevelFaqs = document.querySelector('.cs-detail-page');
    useEffect(() => {
        // OE-14763 - hide contact details on FAQ detail pages
        const contactDetailsAlternate = document.querySelector('.experience-contacts');
        if (contactDetailsAlternate && thirdLevelFaqs) {
            contactDetailsAlternate.style.display = 'none';
        }
    }, [thirdLevelFaqs]);
    return (React.createElement("div", { className: "faq-results container" },
        React.createElement("div", { className: "faq-component row justify-center" }, query.length >= 1 && !emptyPrevious && (React.createElement("div", { className: "col-sm-10 col-md-8 col-lg-6 faq-component__container" },
            React.createElement("div", { className: "title" }, t('faqsearch.results').toUpperCase()),
            React.createElement("button", { className: "button button--tertiary button--arrow-left", onClick: () => {
                    setResults([]);
                    setQuery('');
                    customEventBus.emit('faqSearch:back', {});
                } }, t('button.back')),
            results.length === 0 && (React.createElement("div", { className: "row justify-center" },
                React.createElement("div", { className: "col-lg-10 subtitle" }, t('faqsearch.noresults', { text: query })))),
            results.length > 0 && (React.createElement("div", { className: "details" },
                React.createElement(Accordion, { results: results }, results === null || results === void 0 ? void 0 : results.map((result, i) => (React.createElement(AccordionItem, { callbackOnOpen: () => analytics.selectedElement(query), key: i, title: getHtmlContent(result.name), accordionId: i + '', itemClass: "faq--card", headerClass: "accordion__header--lc" },
                    React.createElement("div", { className: "faq--card-body" }, getHtmlContent(result.body))))))))))),
        React.createElement(GiftcardBalanceFAQ, { results: results })));
};
export default FaqResults;
